import { name, email, role } from "./validations";

export const AdminValidate = {
  name,
  email,
  role,
};
